import { render, staticRenderFns } from "./popup-save-name.vue?vue&type=template&id=9ea785f6&scoped=true&"
import script from "./popup-save-name.vue?vue&type=script&lang=js&"
export * from "./popup-save-name.vue?vue&type=script&lang=js&"
import style0 from "./popup-save-name.vue?vue&type=style&index=0&id=9ea785f6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ea785f6",
  null
  
)

export default component.exports